import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=3d985f8d&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=3d985f8d&prod&lang=scss"
import style1 from "./AddForm.vue?vue&type=style&index=1&id=3d985f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d985f8d",
  null
  
)

export default component.exports